<template>
    <div class="dialog draggable-item-little bg-light light w-100-sm w-100-md w-75-lg w-50-xl" id="policy_dialog">
        <div class="dialog-title pl-10">
            {{ $t('Add policies to {0}', { 0: device.pc_name }) }}
            <span class="button square closer" @click="$root.$emit('CLOSEDEVICEPOLICYVIEWDIALOG')"></span>
        </div>
        <div class="dialog-content overflow bg-light"> 
            <div v-if="policyType_selected" class="row h-100">
                
                <ul class="sidebar-menu col-5 pl-2 bd-gray border-right">
                    <li v-for="policyType in policyType_list" v-if="policyType.related_entity == 'PC'" @click="policyType_selected = policyType" class="pb-5"  
                    :class="{ 'bg-white pl-3 rounded': policyType_selected?.id == policyType.id }">
                        <a class="pl-0 m-0 text-bold" >{{ $t(policyType.name) }}</a>
                        <small>{{ $t(policyType.description) }}</small>
                    </li>   
                </ul>
                <div v-if="policiesGroupedByType[policyType_selected?.id] == undefined" class="col-7 p-4 d-flex flex-align-center flex-justify-center flex-column">
                    <NoDataAvailable :message="$t('No policy configured')"/>
                </div>
                <div v-else class="col-7 px-4">
                    <ul>
                        <li v-for="policy in policiesGroupedByType[policyType_selected?.id]"
                        class="p-2 m-1 d-flex flex-align-center flex-justify-start no-border">
                            <input type="checkbox" :value="policy.id" v-model="policiesSelected" data-caption-position="right" data-role="checkbox" :data-on="true">
                            <label>{{ $t(policy.name) }}</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        
        <div class="dialog-actions">
            <button class="button secondary" @click="$root.$emit('OPENPOLICYVIEWDIALOG', null, $session.getPCList())">
                <span class="icon mif-2x mif-add"></span>
                <span>{{ $t("Add Policy") }}</span>
            </button>
            <button class="button secondary" @click="savePolicies">{{ $t("Save") }}</button>
            <button class="button ml-2" @click="$root.$emit('CLOSEDEVICEPOLICYVIEWDIALOG')">{{ $t("Close") }}</button>
        </div>
    </div>

</template>
<script>
import { draggableMixin } from '../../../mixins/draggable-mixin'
import NoDataAvailable from '../../utils/NoDataAvailable.vue';

export default {

    mixins: [draggableMixin],
    name: "PolicyDeviceDialog",
    data() {
        return {
            policyType_list: null,
            policyType_selected: null,
            policiesSelected: [],
            policiesGroupedByType: null
        }
    },
    components: {
        NoDataAvailable
    },
    props: {
        device: {
            type: Object,
            required: true
        },
        policiesList: {
            type: Array,
            required: true
        },
    },
    mounted: function () {
        this.policyType_list = this.$session.getPolicyTypes("PC");
        this.policyType_selected = this.policyType_list.length != 0 ? this.policyType_list[0] : null;
        this.policiesSelected = this.policiesList.filter(p => p.related_entity == 'PC').map(policy => policy.id);
        this.policiesGroupedByType = this.$session.getPolicies('PC').reduce(function (map, p) {
            map[p.id_type] = map[p.id_type] || [];
            map[p.id_type].push(p);
            return map;
        }, Object.create(null));

        this.$root.$on("refreshPolicies", () => {

            this.$root.$emit('CLOSEDEVICEPOLICYVIEWDIALOG');

            setTimeout(async () => {

                var newPCPolicies = await this.$api.getPCPoliciesList(this.device.id);
                this.$root.$emit('OPENDEVICEPOLICYVIEWDIALOG', this.device, newPCPolicies);
            }, 500);

        });
    },
    beforeDestroy() {
        this.$root.$off("refreshPolicies");
    },
    methods: {

        async savePolicies() {
            let self = this;

            this.$api.setDevicePoliciesList(self.device.id, self.policiesSelected).then((response) => {
                //this.$root.$emit("refreshPolicies");
                this.$root.$emit('CLOSEDEVICEPOLICYVIEWDIALOG');
            });
        },


    }
}
</script>